export default __webpack_public_path__ + "static/media/Games-2.db7e4e29.png";